import { render, staticRenderFns } from "./wordSelect.vue?vue&type=template&id=282b2aa4&scoped=true&"
import script from "./wordSelect.vue?vue&type=script&lang=js&"
export * from "./wordSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b2aa4",
  null
  
)

export default component.exports